var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cx, css } from "@emotion/css";
var Button = function (_a) {
    var text = _a.text, className = _a.className, props = __rest(_a, ["text", "className"]);
    return (_jsx("button", __assign({}, props, { className: cx(css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          display: inline-block;\n          text-align: center;\n          vertical-align: center;\n          cursor: pointer;\n          line-height: 1.3;\n          white-space: nowrap;\n          height: 36px;\n          font-size: 14px;\n          border: 1px solid transparent;\n          border-radius: 8px;\n          font-weight: 500 !important;\n          background: rgb(255, 72, 90);\n          color: rgb(255, 255, 255);\n        "], ["\n          display: inline-block;\n          text-align: center;\n          vertical-align: center;\n          cursor: pointer;\n          line-height: 1.3;\n          white-space: nowrap;\n          height: 36px;\n          font-size: 14px;\n          border: 1px solid transparent;\n          border-radius: 8px;\n          font-weight: 500 !important;\n          background: rgb(255, 72, 90);\n          color: rgb(255, 255, 255);\n        "]))), className) }, { children: text })));
};
export default Button;
var templateObject_1;
